import React from 'react';
import styles from '../styles/Support.module.css';

const TicketModal = ({ ticket, onClose }) => {
  if (!ticket) return null;
  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h3>Ticket #{ticket.id}</h3>
        <div><strong>Customer:</strong> {ticket.customer}</div>
        <div><strong>Email:</strong> {ticket.email}</div>
        <div><strong>Subject:</strong> {ticket.subject}</div>
        <div><strong>Date:</strong> {ticket.date}</div>
        <div style={{ margin: '1rem 0' }}><strong>Message:</strong><br />{ticket.message}</div>
        <button className={styles.closeBtn} onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

export default TicketModal;
